import React, { forwardRef } from 'react'
import cx from 'clsx'
import { Link as GatsbyLink } from 'gatsby'
import MuiLink from '@material-ui/core/Link'
// styles
import useStyles from './Link.style'

const Link = (props, ref) => {
  const classes = useStyles()
  const { className } = props
  return (
    <MuiLink
      className={cx(classes.link, className)}
      component={GatsbyLink}
      ref={ref}
      {...props}
    />
  )
}

export default forwardRef(Link)
